import React, { useRef } from 'react';
import logoSrc from '../img/logo.png'; 
import './Mainservices.css'; 
import ContactForm from '../ContactForm';



function AppDevelopment() {
  const contactFormRef = useRef(); // Reference for controlling the contact form
  const handleOpenContactForm = () => {
    if (contactFormRef.current) {
      contactFormRef.current.openForm(); // Ensure the `ContactForm` has this method.
    }
  };
  return (

    <>
    
      {/* Hero Section */}
      <div className="banner-logo" id="sectionBanner1">
        {logoSrc && <img src={logoSrc} alt="Shigjeta Logo" />}
      </div>
      <section className="banner-section" id="sectionBanner">
        <div className="banner-container">
          {/* Left Side Content */}
          <div className="banner-text">
            <h1 className="banner-title" >boost your presence with an app</h1>
            <p className="banner-description">
            At Shigjeta, we turn ideas into scalable, user-friendly mobile and web apps for seamless experiences
            </p>
            <a
              onClick={handleOpenContactForm} // Open the form on button click
              className="banner-button"
            >
              Start Now
            </a>
          </div>
          {/* Background Image */}
          <div className="banner-background"></div>
        </div>
      </section>
      <div className='img-background'>
      <img
              className="img"
              id='banner1-video'
              src="/img/Main Services Thumbnail.png"  // This should be correct if the video is in the public folder
              autoPlay
              muted
              loop
              playsInline
              onError={(e) => console.error('Error loading video:', e)}  // Error logging for debugging
              alt="img"
            />
      </div>

      {/* Custom App Development Section */}
      <section className="about-section">
        <div className="about-row">
          <div className="about-text">
            <h2><strong>Custom App Development</strong></h2>
            <p>
              We build tailored applications that meet your unique business requirements, ensuring smooth performance and an engaging user experience.
            </p>
            <ul>
              <p><strong>Mobile Apps:</strong> iOS, Android, and cross-platform solutions.</p>
              <p><strong>Web Apps:</strong> Progressive and responsive web applications.</p>
              <p><strong>Custom Features:</strong> Integrations that suit your needs.</p>
              <p><strong>Scalability:</strong> Apps that grow with your business.</p>
            </ul>
          </div>
          <div className="about-image">
            <img src="/img/m4.1.png" alt="Custom App Development" />
          </div>
        </div>

        {/* Mobile App Development Section */}
        <div className="about-row reverse">
          <div className="about-text">
            <h2><strong>Mobile App Development</strong></h2>
            <p>
              Build high-quality mobile applications with seamless functionality for iOS, Android, or both using cutting-edge technologies.
            </p>
            <ul>
              <p><strong>iOS Development:</strong> Native apps for Apple devices.</p>
              <p><strong>Android Development:</strong> Apps optimized for Android devices.</p>
              <p><strong>Cross-Platform:</strong> React Native and Flutter development.</p>
              <p><strong>User Experience:</strong> Beautiful, intuitive, and engaging UI/UX.</p>
            </ul>
          </div>
          <div className="about-image">
            <img src="/img/m4.2.png" alt="Mobile App Development" />
          </div>
        </div>

        {/* Web App Development Section */}
        <div className="about-row">
          <div className="about-text">
            <h2><strong>Web App Development</strong></h2>
            <p>
              Leverage powerful web applications that deliver excellent performance, accessibility, and user engagement on all devices.
            </p>
            <ul>
              <p><strong>Progressive Web Apps:</strong> Offline-capable and lightning fast.</p>
              <p><strong>Responsive Design:</strong> Seamless experiences across all screens.</p>
              <p><strong>APIs & Integrations:</strong> Connecting systems and services efficiently.</p>
              <p><strong>Scalable Architecture:</strong> Built to handle traffic and growth.</p>
            </ul>
          </div>
          <div className="about-image">
            <img src="/img/m4.3.png" alt="Web App Development" />
          </div>
        </div>

        {/* App Optimization Section */}
        <div className="about-row reverse">
          <div className="about-text">
            <h2><strong>App Optimization</strong></h2>
            <p>
              Enhance app performance, speed, and user experience through optimization and continuous improvements.
            </p>
            <ul>
              <p><strong>Performance Tuning:</strong> Optimize app load times and responsiveness.</p>
              <p><strong>UI/UX Enhancement:</strong> User-friendly designs for engagement.</p>
              <p><strong>Bug Fixes:</strong> Ensure smooth operation with zero errors.</p>
              <p><strong>Scalability:</strong> Optimize for growing users and traffic.</p>
            </ul>
          </div>
          <div className="about-image">
            <img src="/img/m4.4.png" alt="App Optimization" />
          </div>
        </div>

        {/* Success Stories Section */}
        <div className="about-row">
          <div className="about-text">
            <h2><strong>Success Stories</strong></h2>
            <p>
              Explore how our app development expertise has helped businesses turn their visions into successful applications.
            </p>
            <a href="/blog" className="cta-button">Read Case Studies</a>
          </div>
          <div className="about-image">
            <img src="/img/m4.5.png" alt="App Development Success Stories" />
          </div>
        </div>
      </section>
      <ContactForm ref={contactFormRef} />
    </>
  );
}

export default AppDevelopment;
